import { render, staticRenderFns } from "./DelegationList.vue?vue&type=template&id=534a1a01&scoped=true&lang=pug&"
import script from "./DelegationList.vue?vue&type=script&lang=ts&"
export * from "./DelegationList.vue?vue&type=script&lang=ts&"
import style0 from "./DelegationList.vue?vue&type=style&index=0&id=534a1a01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534a1a01",
  null
  
)

export default component.exports